import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchExternalMediaCase = async ({ caseId, mediaType }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/photos/get_external_media/`, {
    params: { photo_session_id: caseId, media_type: mediaType },
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetExternalMediaCase = ({ caseId, mediaType, enabled = true }) => {
  return useQuery({
    queryKey: ["external_media_case", caseId, mediaType],
    queryFn: () => fetchExternalMediaCase({ caseId, mediaType }),
    enabled: enabled && Boolean(caseId),
  });
};

export default useGetExternalMediaCase;
